// ============================================================================
// buildSignupMetadata — cleans up what a new person typed on the sign-up form
// before it is sent to Supabase. The database sign-up trigger reads exactly
// these key names, so do not rename them.
// The mobile app keeps an identical copy (ChMSmobile/src/frame/signup.js).
// ============================================================================

// The three things a person can say they are interested in.
const ALLOWED_INTERESTS = ['prayer', 'marketplace', 'missions'];

// Trim spaces; empty text becomes null.
function clean(value) {
  if (value === undefined || value === null) return null;
  const text = String(value).trim();
  return text === '' ? null : text;
}

// Turn any common Kenyan phone format into +2547XXXXXXXX / +2541XXXXXXXX.
// Anything that is not a valid Kenyan mobile number becomes null.
export function normalisePhone(value) {
  const digits = String(value || '').replace(/[^\d]/g, '');
  let local = null;
  if (/^254[17]\d{8}$/.test(digits)) local = digits.slice(3);
  else if (/^0[17]\d{8}$/.test(digits)) local = digits.slice(1);
  else if (/^[17]\d{8}$/.test(digits)) local = digits;
  return local ? `+254${local}` : null;
}

// Build the object passed as options.data to supabase.auth.signUp().
export function buildSignupMetadata(form) {
  const year = parseInt(clean(form.year_of_birth), 10);
  const interests = Array.isArray(form.interests)
    ? form.interests.filter((i) => ALLOWED_INTERESTS.includes(i))
    : [];

  const metadata = {
    full_name: clean(form.full_name),
    phone: normalisePhone(form.phone),
    gender: clean(form.gender),
    city: clean(form.city),
    profession: clean(form.profession),
    home_church: clean(form.home_church),
    pastor_name: clean(form.pastor_name),
    pastor_phone: normalisePhone(form.pastor_phone),
    year_of_birth: Number.isNaN(year) ? null : year,
    interests,
    wants_cnom: form.wants_cnom === true,
  };

  // Only send a referral code when one was typed in.
  const code = clean(form.referral_code);
  if (code) metadata.referral_code = code.toUpperCase();

  return metadata;
}
